<template>
  <div class="e-registration-public-term-cond">
    <!-- <h5 class="text-center" v-dompurify-html="$t('termCondTitle')"></h5>
    <section class="e-registration-public-term-cond__term-cond">
      <p style="white-space: break-spaces;">{{ termCond }}</p>
    </section> -->
    <b-card class="e-registration-public-term-cond__term-cond" tabindex="0">
      <TermsAndConditions />
    </b-card>
    <b-card class="e-registration-public-term-cond__term-cond" tabindex="1">
      <PrivacyPolicyStatement />
    </b-card>
    <b-card class="e-registration-public-term-cond__term-cond" tabindex="2">
      <PersonalInformationCollection />
    </b-card>
    <section class="e-registration-public-term-cond__term-cond-checkbox" tabindex="3">
      <validation-provider
        name="TermsAndCondition"
        :rules="{ required: { allowFalse: false } }"
        v-slot="validationContext"
      >
        <b-form-group>
          <b-form-checkbox
            v-model="accepted"
            :state="getValidationState(validationContext)"
          >
            {{ $t("termCond") }}
          </b-form-checkbox>
        </b-form-group>
      </validation-provider>
    </section>
  </div>
</template>

<script>
import TermCondTxt from "raw-loader!@/assets/term-cond.txt";
import PrivacyPolicyStatement from "@/public/modules/pia/components/PrivacyPolicyStatement";
import TermsAndConditions from "@/public/modules/pia/components/TermsAndConditions";
import PersonalInformationCollection from "@/public/modules/pia/components/PersonalInformationCollection";

export default {
  components: {
    PrivacyPolicyStatement,
    TermsAndConditions,
    PersonalInformationCollection
  },
  props: {
    value: {}
  },
  computed: {
    accepted: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  data() {
    return {
      termCond: TermCondTxt,
      form: { telephone: "" }
    };
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.e-registration-public-term-cond {
  display: flex;
  flex-direction: column;
  height: 130vh;

  section {
    margin: 1rem 0;
  }

  &__term-cond {
    overflow: auto;
    height: 60vh;
  }
}
</style>

<i18n>
{
  "en": {
    "termCond": "I have read and agreed to the above Terms and Conditions for Use of ESH, Privacy Policy Statement for ESH and Personal Information Collection Statement.",
    "termCondTitle": "Terms and Conditions"
  },
  "zh_hk": {
    "termCond": "我已閱讀並同意上述使用條款及細則，隱私政策，及個人資料收集聲明。",
    "termCondTitle": "條款與協議"
  },
  "zh_cn": {
    "termCond": "我已阅读并同意上述使用条款及细则，隐私政策，及个人资料收集声明。",
    "termCondTitle": "条款与协议"
  }
}

</i18n>
